import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from 'react';

import { hot } from 'react-hot-loader';
import { useMutation } from '@apollo/client';
import { connect } from 'react-redux';
import { TrackingContext } from '@vrbo/react-event-tracking';
import withPageFlow from '../../components/PageFlow/PageFlow';
import { VRBO_HANDLER } from '../../components/PageFlow/PageList';
import { CREATE_PROPERTY } from './graphql/query';
import { buildPayload, onComplete, onError } from './utils/propertyCreation';
import { mapDispatchToProps, mapStateToProps, proptypes } from './properties';
import { ExperimentCtx } from '../experiments';
import { EGTNL_TESTS_MPAAS } from '../../../server/api/abacus/constants';

export const VrboCtx = createContext();

export const VrboHandler = (props) => {
    const {
        children,
        setCreatePropertyError
    } = props;
    const { experimentEvaluations } = useContext(ExperimentCtx);
    const { trigger } = useContext(TrackingContext);
    const [loading, setLoading] = useState(false);
    const [competitorLinkValue, setCompetitorLinkValue] = useState('');
    const [createProperty, createPropertyState] = useMutation(CREATE_PROPERTY);

    const {
        [EGTNL_TESTS_MPAAS.ULX_ADDRESSV2_VR]: isAddressV2
    } = experimentEvaluations || {};
    useEffect(() => {
        setLoading(createPropertyState.loading);
    }, [createPropertyState.loading]);

    const setCompetitorLinkValueFn = (value) => {
        setCompetitorLinkValue(value);
    };
    const callCreateProperty = async (pageName = 'Estimateresults') => {
        setCreatePropertyError(null);
        const trustPayload = window.trustApi.getTrustPayload();
        const propsToPass = {
            ...props,
            trigger,
            pageName,
            competitorLinkValue,
            trustPayload,
            isAddressV2: isAddressV2 === 1
        };
        const payload = buildPayload(propsToPass);
        await createProperty({
            variables: {
                property: payload
            }
        }).then(
            (data) => { onComplete({ ...propsToPass, competitorLinkValue })(data); },
            onError(propsToPass)
        )
            .catch(onError(propsToPass));
    };

    return (
        <VrboCtx.Provider value={{
            callCreateProperty,
            loading,
            setCompetitorLinkValue: setCompetitorLinkValueFn
        }}
        >
            {children}
        </VrboCtx.Provider>
    );
};

VrboHandler.propTypes = proptypes;
const connectedVrboHandler = connect(mapStateToProps, mapDispatchToProps)(VrboHandler);

connectedVrboHandler.displayName = VRBO_HANDLER;
export default hot(module)(withPageFlow(connectedVrboHandler));
